$(document).ready(function () {
    if ($('#featured-video').length) {
        var $window = $(window);
        var $featuredMedia = $("#featured-media");
        var $featuredVideo = $("#featured-video");
        var top = $featuredMedia.offset().top;
        var offset = Math.floor(top + ($featuredMedia.outerHeight() / 2));
        $window.on("resize", function () {
            top = $featuredMedia.offset().top;
            offset = Math.floor(top + ($featuredMedia.outerHeight() / 2));
        }).on("scroll", function () {
            $featuredVideo.toggleClass("is-sticky",
                $window.scrollTop() > offset
            );
            var diff = $('#proportional-anchor-1').offset().top + $('#proportional-anchor-1').outerHeight() - ($window.scrollTop() + 80 + $featuredVideo.outerHeight());
            if (diff < 0) {
                $featuredVideo.css({
                    '-webkit-transform': 'translate(0px, ' + diff + 'px)',
                    '-moz-transform': 'translate(0px,' + diff + 'px)',
                    '-ms-transform': 'translate(0px,' + diff + 'px)',
                    '-o-transform': 'translate(0px,' + diff + 'px)',
                    'transform': 'translate(0px,' + diff + 'px)'
                });
            }
            else {
                $featuredVideo.css({
                    '-webkit-transform': '',
                    '-moz-transform': '',
                    '-ms-transform': '',
                    '-o-transform': '',
                    'transform': ''
                });
            }
        });
    }
});